import React from "react";
import { Typography, TypographyProps } from "@mui/material";

export interface Highlight {
  word: string;
  color: string;
}

interface HighlightedTypographyProps extends TypographyProps {
  text: string;
  highlights: Highlight[];
}

export const HighlightedTypography: React.FC<HighlightedTypographyProps> = ({
  text,
  highlights,
  ...typographyProps
}) => {
  const sortedHighlights = [...highlights].sort((a, b) => b.word.length - a.word.length);
  let parts: (string | JSX.Element)[] = [text];

  for (const { word, color } of sortedHighlights) {
    parts = parts.flatMap((part) => {
      if (typeof part !== "string") return [part];
      const segments = part.split(new RegExp(`(${word})`, "gi"));
      return segments.map((seg, i) =>
        seg.toLowerCase() === word.toLowerCase() ? (
          <span key={`${word}-${i}`} style={{ color }}>
            {seg}
          </span>
        ) : (
          seg
        )
      );
    });
  }

  return (
    <Typography {...typographyProps}>
      {parts}
    </Typography>
  );
};
